import styled from 'styled-components';

export const TextWeb = styled.div`
    font-size: 14px;
`;
